<div>
    <mat-paginator #Paginator
                    (page)="pageEvent($event)"
                    [length]="totalCount"
                    [pageSize]="pageSize"
                    aria-label="Select page">
    </mat-paginator>
</div>
  